import { postFetcher } from "utils/fetcher";
import { API_POST_LEAD } from "config/api";

export default async function createLead(data) {
  return postFetcher(API_POST_LEAD, data);
}
